<template>
  <section :id="section.id" class="wagb-home__what-is">
    <div class="wagb-home__what-is-top">
      <div class="wagb-home__what-is-content">
        <h2 class="wagb-home__what-is-title">
          {{ section.titlePrefix }}
          <span class="wagb-home__what-is-title-highlight">{{ section.titleHighlight }}</span>
        </h2>

        <p
          v-for="(para, idx) in section.paragraphs"
          :key="idx"
          class="wagb-home__what-is-text"
          v-html="para"
        />

        <div class="wagb-home__what-is-note">
          <span class="wagb-home__what-is-note-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="22" height="22">
              <circle cx="12" cy="12" r="11" fill="#25d366" />
              <path fill="#fff" d="M10.2 15.8 7.4 13l1.2-1.2 1.6 1.6 4.6-4.6 1.2 1.2z" />
            </svg>
          </span>
          <p>
            <strong>{{ section.noticeLabel }}</strong>
            {{ section.notice }}
          </p>
        </div>
      </div>

      <div class="wagb-home__what-is-visual">
        <img
          :src="section.illustration"
          :alt="section.illustrationAlt"
          width="520"
          height="520"
          loading="lazy"
        />
      </div>
    </div>

    <div class="wagb-home__app-info-card">
      <h3 class="wagb-home__app-info-title">
        <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
          <path
            fill="#25d366"
            d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 2l5 5h-5V4zM8 13h8v2H8v-2zm0 4h8v2H8v-2z"
          />
        </svg>
        {{ section.appInfoTitle }}
      </h3>

      <div class="wagb-home__app-info-grid">
        <div
          v-for="item in section.appInfoItems"
          :key="item.label"
          class="wagb-home__app-info-item"
        >
          <span class="wagb-home__app-info-icon" v-html="item.icon" />
          <strong class="wagb-home__app-info-label">{{ item.label }}</strong>
          <span class="wagb-home__app-info-value">{{ item.value }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WhatIsSection',
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
};
</script>
